import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import styles from './SocialBanner.module.css';

const SocialBannerContent = ({ title, subtitle, cta, className, onClick }) => (
  <div className={classNames(styles.container, className)}>
    <PageContainer className={styles.content}>
      <div className={styles.textContainer}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      <Button
        buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
        onClick={onClick}
        className={styles.button}
      >
        {cta}
      </Button>
    </PageContainer>
  </div>
);

SocialBannerContent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

SocialBannerContent.defaultProps = {
  className: null,
};

export default SocialBannerContent;
